import React from 'react';
import AdminDashboard from '../components/Admin/AdminDashboard';

const AdminPage: React.FC = () => {
  return <AdminDashboard />;
};

export default AdminPage;
